import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, switchMap } from 'rxjs';
import { map } from 'rxjs/operators';
import { APP_CONFIG, AppConfig } from '@cco/apps/cco-frontend';
import { TenantBaseService } from '@app/shared/services/tenant-base.service';

export interface ConvertUnitRequestEntry {
  amount: number;
  fromUnitId: number;
  toUnitId: number;
}

export type ConvertUnitRequest = ConvertUnitRequestEntry[];

export interface ConvertUnitDimensionRequestEntry {
  amount: number;
  fromUnitId: number;
  /**
   * The conversion ratio must be specified if the dimensions of @param fromUnitId and @param toUnitId are different.
   */
  conversionRatio?: number;
  /**
   * This conversionRatioUnidId must be specified if the dimensions of @param fromUnitId and @param toUnitId are different.
   */
  conversionRatioUnitId?: number;
  toUnitId: number;
}

export type ConvertUnitDimensionRequest = ConvertUnitDimensionRequestEntry[];

@Injectable({
  providedIn: 'root',
})
export class UnitConversionApiService extends TenantBaseService {
  protected http = inject(HttpClient);

  constructor() {
    const config = inject<AppConfig>(APP_CONFIG);

    super(config.apiBaseUrl);
  }

  convert$(amount: number, fromUnitId: number, toUnitId: number): Observable<number> {
    return this.convertMultiple$([{ amount, fromUnitId, toUnitId }]).pipe(
      map(outputs => outputs[0]),
    );
  }

  convertMultiple$(inputs: ConvertUnitRequest): Observable<number[]> {
    return this.tenantBaseUrl$.pipe(
      switchMap(tenantBaseUrl => this.http.post<number[]>(`${tenantBaseUrl}/units/convert`, inputs))
    );
  }

  convertBetweenDimensions$(
    amount: number,
    fromUnitId: number,
    conversionRatio: number,
    conversionRatioUnitId: number,
    toUnitId: number,
  ): Observable<number> {
    return this.convertBetweenDimensionsMultiple$([
      { amount, fromUnitId, conversionRatio, conversionRatioUnitId, toUnitId },
    ]).pipe(map(outputs => outputs[0]));
  }

  public convertBetweenDimensionsMultiple$(inputs: ConvertUnitDimensionRequest): Observable<number[]> {
    return this.tenantBaseUrl$.pipe(
      switchMap(tenantBaseUrl => this.http.post<number[]>(`${tenantBaseUrl}/units/convert-dimensions`, inputs))
    );
  }
}
